import React, { useState } from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaChevronDown, FaChevronUp } from "react-icons/fa"; // Importing icons from react-icons

function ThesteelofIndia() {
  const [showMore, setShowMore] = useState(false);

  const handleReadMore = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      <Container>
      <div class="row">
      <div class="col-12">
        <div class="contentbox">
        <h1 className="cus_text60">STEEL IN EVERY HUE</h1>
        <p className="cus_text30 text-start">
          As a nation, our progress merits celebration, illuminating the unwavering determination of every Indian. To tell this story, we turned to a series of portraits, as diverse as our land itself.{' '}
          <strong style={{ fontWeight: "bold", fontFamily: "Roboto black" }}>
             As raw as real.
          </strong>
          
        </p>
        <p className="cus_text30">
          The ethos of Steel of India was finely crafted into a series of powerful portraits of Indian people from diverse socio-cultural backgrounds by Bharat Sikka. Each image provokes thought, evokes emotion, and leaves a lingering sense of mystery.</p>
        {showMore && (
           <p className="cus_text30">
            Kids, on the way to their school, eyes full of dreams and the future.
            <br/>
             Women, holding it all together – {' '}
            <strong style={{ fontWeight: "bold", fontFamily: "Roboto black" }}>
              soil, homes, hearts, no stone unturned.
            </strong>
            <br />
            Steelworkers, forging tomorrow in the fire of industry.
            <br/>
            Athletes, fighting gravity with grit to rise.
            <br/>
            Tribes, carrying whispers of the old world, forests in their blood.
            <br/>
            Artists, performers, the common man – {' '}
            <strong style={{ fontWeight: "bold", fontFamily: "Roboto black" }}>
              all defining India’s lasting legacy.
            </strong>
            <br/>
            Steel of India portraits, stripped of glamour, set against the backdrop of everyday life, stand as a testament to the resilience that binds us all.
          </p>
        )}
        <button
          onClick={handleReadMore}
          className="btn btn-link p-0 d-flex align-items-center"
          style={{
            fontSize: "18px",
            textDecoration: "none",
            fontWeight: "700",
            color: "GrayText",
          }}
        >
          {showMore ? "Read Less" : "Read More"}{" "}
          {showMore ? (
            <FaChevronUp className="ms-2" />
          ) : (
            <FaChevronDown className="ms-2" />
          )}
        </button>
        </div>
        </div>
        </div>
      </Container>
    </>
  );
}

export default ThesteelofIndia;
